import { render } from "./EventAdd.vue?vue&type=template&id=0d1db414"
import script from "./EventAdd.vue?vue&type=script&lang=js"
export * from "./EventAdd.vue?vue&type=script&lang=js"

import "./EventAdd.vue?vue&type=style&index=0&id=0d1db414&lang=scss&scope=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__